import { render, staticRenderFns } from "./MarcaForm.vue?vue&type=template&id=59cb7946&scoped=true&"
import script from "./MarcaForm.vue?vue&type=script&lang=js&"
export * from "./MarcaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cb7946",
  null
  
)

export default component.exports